import React from 'react';
import Layout from '@/common/Layout';
import FloatingActionButton from '../FloatingActionButton';
import { getLoggedInUser } from 'utilities/helpers';
import { EXECUTIVE, MANAGER } from 'utilities/roleRights';
import FollowUpPage from './components/FollowUpPage';

const FollowUp = () => {
  const user = getLoggedInUser();
  return (
    <Layout sider={false}>
      <FollowUpPage />
      {[MANAGER, EXECUTIVE].includes(user?.user_details?.role_id) ? (
        <FloatingActionButton />
      ) : (
        ''
      )}
    </Layout>
  );
};

export default FollowUp;
